const burgerBtn = document.getElementById('burger-btn');
const languageBtn = document.getElementById('language-btn');
const mobileMenu = document.getElementById('mobile-menu');
const menuBackdrop = document.getElementById('menu-backdrop');
const languageDropdown = document.getElementById('language-dropdown');
const mobileLinks = document.querySelectorAll('#mobile-links');

languageBtn.addEventListener('click', () => {
  languageDropdown.classList.toggle('hidden');
});

mobileLinks.forEach((element) => {
  element.addEventListener('click', () => {
    mobileMenu.classList.add('hidden');
  });
});

function toggle() {
  mobileMenu.classList.toggle('menu--open');
  menuBackdrop.classList.toggle('hidden');
}

burgerBtn.addEventListener('click', toggle);
menuBackdrop.addEventListener('click', toggle);
